<template>
  <div
    class="help-container"
    @click="show = true"
  >
    <div class="help-image">
      <img
        class="help-image-screenshot"
        :src="require(`../../assets/${gif_preview}`)"
      >
      <img
        class="help-image-screenshot help-image-screenshot__static"
        :src="require(`../../assets/${img_placeholder}`)"
      >
      <fa-icon
        class="help-image-icon"
        icon="play-circle"
      />
    </div>
    <div class="help-text">
      ¿Necesitas ayuda?
    </div>
    <base-modal
      id="HelpVideo"
      title="¿Necesitas ayuda?"
      :show="show"
      :size="calculatedSize"
      @closed="close"
      @shown="startVideo"
    >
      <video-player
        ref="videoPlayer"
        class="video-player-box"
        :options="playerOptions"
      />
      <template slot="footer">
        <base-button
          inverse
          @click="close"
        >
          Cerrar
        </base-button>
      </template>
    </base-modal>
  </div>
</template>

<script>
// import $ from 'jquery';

/* eslint-disable import/no-extraneous-dependencies */
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';

export default {
    name: 'HelpVideo',
    components: {
        videoPlayer,
    },
    props: [
        'src',
        'img_placeholder',
        'gif_preview',
    ],
    data() {
        return {
            show: false,
            video_src: this.src,
            video_img: this.img_placeholder,
            playerOptions: {
                fluid: true,
                controls: true,
                autoplay: false,
                sources: [],
            },
        };
    },
    computed: {
        player() {
            return this.$refs.videoPlayer.player;
        },
        calculatedSize() {
            const height = window.innerHeight;
            if (height > 700) {
                return 'modal-xl';
            }
            return 'modal-lg';
        },
    },
    methods: {
        close() {
            this.player.pause();
            this.player.currentTime(0);
            this.show = false;
        },
        startVideo() {
            this.player.play();
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.playerOptions.sources.push(
                {
                    type: 'video/mp4',
                    src: this.video_src,
                },
            );
        });
    },
};
</script>

<style lang="scss" scoped>
.help-container {
    border: solid 1px $primary;
    margin-bottom: 1rem;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
}
.help-image {
    background: $primary;
    // margin: -1rem;
    // margin-bottom: 1rem;
    min-height: 100px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 3rem;
    position: relative;
    overflow: hidden;
}
.help-text {
    color: $primary;
    text-align: center;
    padding: 0.5rem;
}
.help-image-screenshot {
    position: absolute;
}
.help-image-icon {
    position: absolute;
    transition: all 0.5s;
}
.help-image-screenshot__static {
    transition: all 0.5s;
}
.help-container:hover .help-image-screenshot__static {
    opacity: 0;
}
.help-container:hover .help-image-icon {
    opacity: 0.3;
}
</style>
